// extracted by mini-css-extract-plugin
export default {"normalcn":"styles_normalcn__oxy6O","normalen":"styles_normalen__2D-KT"};